// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"457":"b8abb6407b3d4a24","725":"f54c09b7e187aa26"}[chunkId] + ".js";
};